module.exports = __webpack_public_path__ + "img/slide11-piece-13.7e2efb4e.png";